namespace('compass.hotel');

compass.hotel.ReservationBannerWidget = compass.defineWidget(function ReservationBannerWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;

	var _render = this.render = function(widgetElem) {
		widgetElem.append(
			d.h2({ className : 'reservationBanner' }, _settings.message,
				d.reader('View details and make changes')
			),
			d.div({ className : 'northWestTriangle' })
		);
	};
	
	var d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultReservationBannerWidgetWUID',
	widgetName : 'ReservationBannerWidget',
  message : ''
});
